import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const IndexRedirect = ({ redirectRoute }: { redirectRoute: string }) => {
  const router = useRouter();

  useEffect(() => {
    if (
      redirectRoute.startsWith('http://') ||
      redirectRoute.startsWith('https://')
    ) {
      window.location.replace(redirectRoute);
      return;
    }
    void router.replace(redirectRoute);
  }, [router, redirectRoute]);

  return null;
};
